import axiosInstance from "./axios-instance";

const createQboEstimate = async (payload: any) => {
    try {
        const response = await axiosInstance.post<any>(
            `/quickBooks/export_prototype`,
            payload
        );

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export { createQboEstimate };
